module.exports = __webpack_public_path__ + "static/media/IconAddCatMargin.5fd61663.svg";